import { render, staticRenderFns } from "./TaskTasktempHistoricDetail.vue?vue&type=template&id=009c79f8"
import script from "./TaskTasktempHistoricDetail.vue?vue&type=script&lang=js"
export * from "./TaskTasktempHistoricDetail.vue?vue&type=script&lang=js"
import style1 from "./TaskTasktempHistoricDetail.vue?vue&type=style&index=1&id=009c79f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports